import { create } from 'zustand'

/** Sent on every request while an administrator bypasses permissions. */
export const PERMISSION_BYPASS_HEADER = 'X-Arvoke-Bypass-Permissions'

interface PermissionBypassState {
  /** Every request skips permission checks (the server allows it only for administrators). */
  bypassing: boolean
  setBypassing: (bypassing: boolean) => void
}

/**
 * An administrator's Bypass Permissions switch (the Me menu). Kept in memory
 * only, never stored: every page load starts with it off, so it's always
 * turned on on purpose.
 */
export const usePermissionBypassStore = create<PermissionBypassState>()((set) => ({
  bypassing: false,
  setBypassing: (bypassing) => set({ bypassing }),
}))

/** The bypass header while it's on, for requests sent outside apiClient. */
export function permissionBypassHeaders(): Record<string, string> {
  return usePermissionBypassStore.getState().bypassing ? { [PERMISSION_BYPASS_HEADER]: 'true' } : {}
}
